import React from "react";
import { Col, Row, Form } from "reactstrap";
import info from "../../../../images/info_black_24dp.png";
import "./invite-respondants-modal.css";
import Renderforminput from "./invite-respondants-input";
import Responsiveforminput from "./Responsive/Invitation-Inputs";
import Renderpopoverinner from "./Popover-inner";
const Renderinviterespondantsmodal = (props) => {
  const calcWidth = window.innerWidth;

  return (
    <React.Fragment>
      <div className="info">
        <img className="info-icon" src={info} />
        {props.isPopOverOpenRelationshipName && (
          <div className="info-popover">
            <Renderpopoverinner
              relationShipName={props.relationShipName}
              handleClosePopOver={props.handleClosePopOver}
            />
          </div>
        )}
        <p className="info-text">Invite a minimum of three people.</p>
      </div>
      <Form onSubmit={props.handleModalFormSubmit}>
        <Row form>
          <Col>
            <p className="form-label">email id</p>
          </Col>
          <Col>
            <p className="form-label">relationship</p>
          </Col>
        </Row>

        {calcWidth <= 767 ? (
          <Responsiveforminput
            inputFields={props.inputFields}
            dropDownOptions={props.dropDownOptions}
            handleMultipleEmail={props.handleMultipleEmail}
            isEmailValid = {props.isEmailValid}
            handleMultipleSelect={props.handleMultipleSelect}
            handleInputFields={props.handleInputFields}
            isChecked={props.isChecked}
            isDisabled={props.isDisabled}
            handleInviteModalSubmit={props.handleInviteModalSubmit}
            isPopOverOpenRelationshipId={props.isPopOverOpenRelationshipId}
          />
        ) : (
          <div>
            {props.overlayIsVisible && <div className="overlay"></div>}
            <Renderforminput
              inputFields={props.inputFields}
              dropDownOptions={props.dropDownOptions}
              handleMultipleEmail={props.handleMultipleEmail}
              isEmailValid = {props.isEmailValid}
              handleMultipleSelect={props.handleMultipleSelect}
              handleInputFields={props.handleInputFields}
              isChecked={props.isChecked}
              isDisabled={props.isDisabled}
              handleInviteModalSubmit={props.handleInviteModalSubmit}
              isPopOverOpenRelationshipId={props.isPopOverOpenRelationshipId}
            />
          </div>
        )}
      </Form>
    </React.Fragment>
  );
};

export default Renderinviterespondantsmodal;



// WEBPACK FOOTER //
// ./src/new/Components/CompletedAssessment/Invite-Respondants-Modal/invite-respondants-modal.jsx